var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6582 43.8987C24.6001 44.3102 24.5701 44.7307 24.5701 45.1582C24.5701 50.0876 28.5662 54.0837 33.4956 54.0837C38.425 54.0837 42.4211 50.0876 42.4211 45.1582C42.4211 44.7307 42.3911 44.3102 42.333 43.8987H63.9912V63.7531C63.9912 64.9854 62.9922 65.9845 61.7598 65.9845H5.23138C3.99902 65.9845 3 64.9854 3 63.7531V43.8987H24.6582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1649 43.6707C43.1649 49.0109 38.8358 53.34 33.4956 53.34C28.1554 53.34 23.8263 49.0109 23.8263 43.6707C23.8263 43.4977 23.8308 43.3257 23.8398 43.1549H3L10.111 22.1295C10.4176 21.2231 11.2679 20.613 12.2248 20.613H54.7664C55.7233 20.613 56.5736 21.2231 56.8802 22.1295L63.9912 43.1549H43.1514C43.1604 43.3257 43.1649 43.4977 43.1649 43.6707Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5967 43.5377C42.5967 48.0876 38.522 52.5962 33.4956 52.5962C28.4692 52.5962 24.3944 48.0876 24.3944 43.5377C24.3944 43.3903 24.3987 42.4237 24.4072 42.2782H7.25229L13.9454 26.0047C14.234 25.2324 15.0344 24.7126 15.935 24.7126H51.0562C51.9568 24.7126 52.7572 25.2324 53.0457 26.0047L59.7389 42.2782H42.584C42.5925 42.4237 42.5967 43.3903 42.5967 43.5377Z",
    fill: "#E7ECFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92974 43.3079V63.0093C3.92974 63.7282 4.51251 64.3109 5.23138 64.3109H61.7598C62.4787 64.3109 63.0614 63.7282 63.0614 63.0093V43.3079L55.9994 22.4273C55.8206 21.8986 55.3246 21.5427 54.7664 21.5427H12.2248C11.6666 21.5427 11.1706 21.8986 10.9917 22.4273L3.92974 43.3079Z",
    stroke: "#1F64E7",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4131 42.927C16.3411 42.927 19.501 42.927 22.8927 42.927C24.2883 42.927 24.2883 43.9078 24.2883 44.4146C24.2883 49.344 28.3763 53.3401 33.4192 53.3401C38.462 53.3401 42.5501 49.344 42.5501 44.4146C42.5501 43.9078 42.5501 42.927 43.9456 42.927H62.5036M7.88951 42.927H9.69416H7.88951Z",
    stroke: "#1F64E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1646 6.20035L43.9087 15.4629M32.8259 3V15.4629V3ZM13.4131 6.20035L21.669 15.4629L13.4131 6.20035Z",
    stroke: "#B8C6F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.d798da1033983b209040cc783bd67ca4.svg";
export { ForwardRef as ReactComponent };